<div
  class="component"
  [@enterAnimation]="((isVisible | async) || false).toString()"
  (onOutsideClick)="clickOutsideSubject.next($event)"
  [ngStyle]="{ 'box-shadow': boxShadow }"
  data-automation-e2e-selector="profileOverviewContainer"
  [attr.data-automation-e2e-item-state]="(isVisible | async) || false"
>
  <div class="header">
    <div
      class="activeAccountContainer"
      data-automation-e2e-selector="profileOverviewName"
    >
      <div>
        <p
          class="dynamic-ellipsis-text"
          [title]="activeAccount | async"
          [textContent]="activeAccount | async"
        ></p>
      </div>
    </div>
    <div class="moneyType">
      <muni-gameday-money-type></muni-gameday-money-type>
    </div>
    <i
      [ngClass]="['fa', 'fa-times', 'xButton']"
      [hidden]="false"
      (click)="close()"
      data-icon
      data-automation-e2e-selector="profileOverviewXButton"
    ></i>
  </div>
  <div
    class="cardsContainer"
    #cardsContainer
    data-automation-e2e-selector="profileOverviewScroller"
  >
    <muni-gameday-portfolio
      data-automation-e2e-selector="portfolioOverviewCardContainer"
    ></muni-gameday-portfolio>
    <muni-gameday-order-summary-card
      data-automation-e2e-selector="orderSummaryCardContainer"
    >
    </muni-gameday-order-summary-card>
  </div>
</div>
